module.exports = __webpack_public_path__ + "img/768_stores_img3.ec8b73ae.png";